<template>
	<div style="border: 1px solid #e5e5e5;border-radius: 10px	;">
		<el-table :row-style="addStyle" :cell-style="cellStyle" @row-click="rowClick"
			:row-class-name="tableRowClassName" :data="tableData" @row-dblclick="rowDblclick" :height="tableHeight"
			:header-cell-style="{ 'background-color': '#e5e5e5' }"  border size="small" v-loading="loading"
			style="width: 100%;border-radius: 10px;">
			<el-table-column prop="img" label="实图" width="50"  header-align="center" show-overflow-tooltip>
				<template #default="scope">
					<div v-if="!scope.row || scope.row.img.length <= 0">
						<div @click="preview(scope.row, scope.row.img)">
							<el-image style="" :src="require('@/assets/img/error_img.png')" loading="lazy" />
						</div>
					</div>
					<div v-else>
						<div @click="preview(scope.row, scope.row.img)">
							<el-image :src="scope.row.img[0]" loading="lazy" />
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="" label="" width="40">
				<template #default="scope">
					<div v-if="scope.row.issus == 1"
						style="display: flex; justify-content: center; align-items: center; gap: 6px; width: 100%;">
						<el-tooltip class="box-item" effect="dark" content="疑似关联，点击查看详情">
							<el-image @click="preview(scope.row, scope.row.img)" style="width:20px;height:20px"
								:src="require('@/assets/img/riLine2.png')" loading="lazy" />
						</el-tooltip>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="stock_type_txt" label="货物状态" header-align="center" width="170" show-overflow-tooltip>
				<template #default="scope">
					<div class="stock_type_txt_button">
						<span v-for="item in scope.row.stock_type_txt_list">
							<el-button class="A" size="small" text bg v-if="item == '二手' || item == '过保' || item == '包附破损'"
								style="">{{ item }}</el-button>
							<el-button class="C" size="small" text bg v-else color="#ff8a5c">{{ item }}</el-button>
						</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="" label="" width="10" />
			<el-table-column prop="brand_name" label="品牌" label-class-name="table-center-label" :width="td_width['brand_name']" show-overflow-tooltip>
				<template #default="scope">
					<span v-if="scope.row.brand_name">
						{{ scope.row.brand_name }}
					</span>
					<span v-else>
						-
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="" label="" width="10" />
			<el-table-column prop="name" label="品名" label-class-name="table-center-label" :width="td_width['name']" show-overflow-tooltip>
				<template #default="scope">
					<span v-if="scope.row.name">
						{{ scope.row.name }}
					</span>
					<span v-else>
						-
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="" label="" width="10" />
			<el-table-column prop="model" label="型号" label-class-name="table-center-label" :min-width="td_width['model']" show-overflow-tooltip>
				<template #default="scope">
					<span v-if="scope.row.model">
						{{ scope.row.model }}
					</span>
					<span v-else>
						-
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="" label="" width="10" />
			<el-table-column prop="order_no" label="订货号" label-class-name="table-center-label" :width="td_width['order_no']" show-overflow-tooltip>
				<template #default="scope">
					<span v-if="scope.row.order_no">
						{{ scope.row.order_no }}
					</span>
					<span v-else>
						-
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="" label="" width="10" />
			<el-table-column prop="tsw_price" label="单价" :width="td_width['price']" show-overflow-tooltip>
				<template #default="scope">
					<el-tooltip placement="top">
						<template #content>
							此信息由用户提供，仅供参考，请与发布用户核实！
							<!-- <br />
							列表年份：{{ scope.row.year }}
							<br />
							列表价：{{ scope.row.price }}
							<br />
							折扣：{{ scope.row.tsw_discount }}
							<br />
							单价：{{ scope.row.tsw_price }} -->
						</template>
						{{ scope.row.tsw_price }}
					</el-tooltip>
				</template>
			</el-table-column>
			<el-table-column prop="" label="" width="10" />
			<el-table-column prop="sur_num" label="库存" width="60" show-overflow-tooltip />
			<el-table-column prop="" label="" width="10" />
			<el-table-column prop="sur_num" label="数量" label-class-name="table-center-label" width="130" show-overflow-tooltip >
				<template #default="scope">
					<span v-if="scope.row.isbadge == 1">	
						<el-input-number @click.stop @dblclick.stop class="num_input" v-model="scope.row.num_input" :min="1"
						:max="scope.row.sur_num" @change="handleChange" size="small" />
							</span>
					<span v-else>
					</span>
					
				</template>
			</el-table-column>
			<el-table-column prop="" label="聊天" :width="td_width['chat']">
				<template #default="scope">
					<div class="caozuo">
						<span v-if="scope.row.isbadge == 1" style="display: inline-block; width: 18px; margin-right: 10px;">
							<el-icon size="18" @click.stop="addToCart(scope.row, $event)" style="color:#ff8a5c;">
								<ShoppingCartFull />
							</el-icon>
						</span>
						<span v-else style="display: inline-block; width: 28px;"></span>
						<span v-if="scope.row.is_open == 1" style="display: inline-block; width: 18px; margin-right: 10px;">
							<img :src="require('@/assets/img/phone-o.png')" @click.stop="showContact(scope.row)"
								style="width: 18px; height: 18px; cursor: pointer;">
						</span>
						<span v-else style="display: inline-block; width: 28px;"></span>
						<img :src="require('@/assets/img/iconPark-comment .png')" @click.stop="chat_click(scope.row.id)"
							style="width: 18px; height: 18px; cursor: pointer;">
						
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="" label="" width="10" />
			<el-table-column prop="type_name" label="用户类型" width="100" show-overflow-tooltip>
			</el-table-column>
		</el-table>
		<examineImg ref="examineImg"></examineImg>
		<chat ref="chat" v-if="chat_info" v-on:closeChat="closeChat($event)"></chat>
		<el-dialog
			v-model="contact_info"
			width="380px"
			:close-on-click-modal="false"
			class="contact-dialog"
			:show-close="false"
		>
			<template #header>
				
			</template>
			<div v-if="current_contact" class="contact-content">
				<div class="contact-card">
					<div class="contact-avatar">
						<div class="avatar-circle">
							<el-icon :size="48"><User /></el-icon>
						</div>
					</div>
					<div class="contact-name">{{ current_contact.user_linkman || '未知联系人' }}</div>
				</div>
				<div class="contact-info-list">
					<div class="info-item">
						<div class="info-icon-wrapper">
							<el-icon><User /></el-icon>
						</div>
						<div class="info-detail">
							<div class="info-tag">联系人</div>
							<div class="info-text">{{ current_contact.user_linkman || '-' }}</div>
						</div>
					</div>
					<div class="info-item" @click="copyPhone">
						<div class="info-icon-wrapper phone-icon">
							<el-icon><Phone /></el-icon>
						</div>
						<div class="info-detail">
							<div class="info-tag">电话</div>
							<div class="info-text phone-text">
								{{ current_contact.user_mobile || current_contact.phone || '-' }}
							</div>
						</div>
						<div class="copy-hint">点击复制</div>
					</div>
				</div>
			</div>
			<template #footer>
				<div class="dialog-footer">
					<el-button class="close-btn" @click="contact_info = false">关闭</el-button>
					<el-button v-if="current_contact?.user_mobile || current_contact?.phone" class="copy-btn" type="primary" @click="copyPhone">
						<el-icon><DocumentCopy /></el-icon>
						复制号码
					</el-button>
				</div>
			</template>
		</el-dialog>
	</div>
</template>
<script>
import '../../assets/search/index.css'
import { ElMessage } from 'element-plus'
import { ShoppingCartFull, User, Phone, DocumentCopy } from '@element-plus/icons-vue'
import examineImg from '../public/img';
import chat from '../public/chat';
export default {
	name: 'TableComponent',
	components: {
		examineImg,
		chat,
		ShoppingCartFull,
		User,
		Phone,
		DocumentCopy
	},
	props: {
		tableData: {
			type: Array,
			default: () => []
		},
		loading: {
			type: Boolean,
			default: false
		},
		user_id: {
			type: String,
			default: ''
		},
		tableHeight: {
			type: Number,
			default: 500
		},
		showCart: {
			type: Boolean,
			default: true
		}
	},
	data() {

		return {
			td_width: {
				brand_name: 100,
				name: 115,
				model: 80,
				order_no: 155,
				chat: 110,
				price: 80
			},
			chat_info: false,
			contact_info: false,
			current_contact: null,
			index: [],
			srcList: [],
		}
	},

	mounted() {
		this.getScreenWidthRange()
	},

	methods: {
		getScreenWidthRange() {
			const viewportWidth = document.documentElement.clientWidth;

			if (viewportWidth >= 1300 && viewportWidth < 1600) {
				this.td_width = {
					brand_name: 100,
					name: 100,
					model: 80,
					order_no: 120,
					chat: 111,
					price: 80
				};
			} else if (viewportWidth >= 960 && viewportWidth < 1300) {
				this.td_width = {
					brand_name: 80,
					name: 60,
					model: 80,
					order_no: 100,
					chat: 111,
					price: 80
				};
			}
		},
		rowClick(row, column, e) {
			this.index = [parseInt(row.index)]
		},
		tableRowClassName({
			row,
			rowIndex
		}) {
			row.index = rowIndex
			return ''
		},
		addStyle({ row, rowIndex }) {
			if (this.index.indexOf(rowIndex) > -1) {
				return { 'background-color': '#F2F6FC' }
			}
		},
		cellStyle({ columnIndex }) {
			if (columnIndex === 0) {
				return { 'background-color': '#fff  !important' }
			}
		},
		closeChat() {
			this.chat_info = false;
		},
		async chat_click(id) {
			await this.$axios.post('/api/yunsys.storage/addchat', { id }).then(async (res) => {
				var res = res.data;
				if (res.code !== 0) {
					return ElMessage({
						message: res.msg,
						type: 'error',
						grouping: true
					})
				};
				this.chat_info = false;
				this.$nextTick(() => {
					this.chat_info = true;
					this.$nextTick(() => {
						this.$refs['chat'].dialogTableVisible = true;
						this.$refs['chat'].pitch_id = res.data.data;
						this.$refs['chat'].admin_pitch_id = res.data.data;
						this.$nextTick(() => {
							this.$refs['chat'].search()
						})
					})
				})

			})
				.catch(err => {
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true

					})
				})
		},
		preview(row, img) {
			this.srcList = [];
			var obj = this;
			img.forEach(function (item) {
				obj.srcList.push(item)
			})
			this.$refs['examineImg'].img_title = row;
			this.$refs['examineImg'].data = this.srcList;
			this.$refs['examineImg'].dialogTableVisible = true;
			this.$refs['examineImg'].imgBigUrl = this.srcList[0];
		},
		rowDblclick(row) {
			const newUrl = this.$router.resolve({ path: '/product', query: { id: row.id } }).href;
			window.open(newUrl, '_blank');
		},
		addToCart(item, event) {
			if (this.showCart) {
				this.$emit('update-cart-count', item)
				this.createFlyAnimation(event)
			}
		},
		createFlyAnimation(event) {
			const cartIcon = event.target
			const rect = cartIcon.getBoundingClientRect()
			
			const flyItem = document.createElement('div')
			flyItem.style.cssText = `
				position: fixed;
				width: 40px;
				height: 40px;
				background: #ff8a5c;
				border-radius: 50%;
				z-index: 9999;
				pointer-events: none;
				left: ${rect.left + rect.width / 2 - 20}px;
				top: ${rect.top + rect.height / 2 - 20}px;
				opacity: 1;
			`
			
			const cartIconElement = document.createElement('div')
			cartIconElement.innerHTML = '<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="white"><path d="M832 312H264v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v136c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-40h168l40 400H184c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h664c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H536l-40-400h336c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"></path></svg>'
			cartIconElement.style.cssText = 'display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;'
			flyItem.appendChild(cartIconElement)
			
			document.body.appendChild(flyItem)
			
			const sidebar = document.querySelector('.floating-sidebar')
			if (!sidebar) {
				setTimeout(() => {
					document.body.removeChild(flyItem)
				}, 100)
				return
			}
			
			const cartItem = sidebar.querySelector('.sidebar-item:nth-child(1)')
			if (!cartItem) {
				setTimeout(() => {
					document.body.removeChild(flyItem)
				}, 100)
				return
			}
			
			const offsetX = 50
			const offsetY = 100
			
			const cartItemRect = cartItem.getBoundingClientRect()
			const startX = rect.left + rect.width / 2
			const startY = rect.top + rect.height / 2
			const midX = cartItemRect.left - offsetX
			const midY = cartItemRect.top - offsetY
			const endX = cartItemRect.left + cartItemRect.width / 2 - 20
			const endY = cartItemRect.top + cartItemRect.height / 2 - 20
			
			const totalDuration = 500
			const phase1Ratio = 0.6
			
			let startTime
			
			const animate = (currentTime) => {
				if (!startTime) startTime = currentTime
				const elapsed = currentTime - startTime
				const progress = Math.min(elapsed / totalDuration, 1)
				
				let x, y, scale, opacity
				
				if (progress < phase1Ratio) {
					const phase1Progress = progress / phase1Ratio
					const t = phase1Progress
					const t2 = t * t
					const t3 = t2 * t
					const mt = 1 - t
					const mt2 = mt * mt
					const mt3 = mt2 * mt
					
					const controlX1 = startX + (midX - startX) * 0.3
					const controlY1 = startY - 80
					const controlX2 = startX + (midX - startX) * 0.7
					const controlY2 = midY - 40
					
					x = mt3 * startX + 3 * mt2 * t * controlX1 + 3 * mt * t2 * controlX2 + t3 * midX
					y = mt3 * startY + 3 * mt2 * t * controlY1 + 3 * mt * t2 * controlY2 + t3 * midY
					scale = 1 - phase1Progress * 0.3
					opacity = 1 - phase1Progress * 0.2
				} else {
					const phase2Progress = (progress - phase1Ratio) / (1 - phase1Ratio)
					const t = phase2Progress
					const t2 = t * t
					const t3 = t2 * t
					const mt = 1 - t
					const mt2 = mt * mt
					const mt3 = mt2 * mt
					
					const controlX1 = midX + (endX - midX) * 0.2
					const controlY1 = midY - 20
					const controlX2 = midX + (endX - midX) * 0.8
					const controlY2 = midY + (endY - midY) * 0.5
					
					x = mt3 * midX + 3 * mt2 * t * controlX1 + 3 * mt * t2 * controlX2 + t3 * endX
					y = mt3 * midY + 3 * mt2 * t * controlY1 + 3 * mt * t2 * controlY2 + t3 * endY
					scale = 0.7 - phase2Progress * 0.4
					opacity = 0.8 - phase2Progress * 0.8
				}
				
				flyItem.style.left = x + 'px'
				flyItem.style.top = y + 'px'
				flyItem.style.transform = `scale(${scale})`
				flyItem.style.opacity = opacity
				
				if (progress < 1) {
					requestAnimationFrame(animate)
				} else {
					if (flyItem.parentNode) {
						document.body.removeChild(flyItem)
					}
				}
			}
			
			requestAnimationFrame(animate)
		},
		async showContact(item) {
			this.current_contact = item
			this.contact_info = true
		},
		copyPhone() {
			const phone = this.current_contact.user_mobile || this.current_contact.phone
			if (!phone) return
			navigator.clipboard.writeText(phone).then(() => {
				ElMessage({
					message: '电话号码已复制到剪贴板',
					type: 'success',
					grouping: true
				})
			}).catch(() => {
				const textArea = document.createElement('textarea')
				textArea.value = phone
				document.body.appendChild(textArea)
				textArea.select()
				document.execCommand('copy')
				document.body.removeChild(textArea)
				ElMessage.success('电话号码已复制到剪贴板')
			})
		}
	}
}
</script>
<style>

</style>
<style lang="less" scoped>
:deep(.table-center-label) {
    border-right: var(--el-table-border) !important;
}

:deep(.el-page-header__header) {

	line-height: 32px;
	margin-left: 30px;
}

:deep(.num_input .el-input__wrapper) {
	box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color)) inset !important;
}

:deep(.acquiesce .el-button:hover) {
	color: #fff;
	background-color: #ff8a5c;
	border-color: #ff8a5c;
	border: 0;
}

:deep(.el-pager .number) {
	display: none
}

:deep(.el-pager .more) {
	display: none
}



:deep(.el-table__row .el-table__cell:nth-child(2)) {
	.el-tooltip {
		padding: 0px;
	}
}

:deep(.el-table th.el-table__cell.is-leaf.table-center-label) {
    border-right: var(--el-table-border) !important;
}

.stock_type_txt_button .el-button {
	margin-right: 5px;
	font-size: 0.70rem !important;
	padding: 0.2525rem 0.5875rem;
}

.stock_type_txt_button .A {
	color: red !important;
	background-color: rgb(255, 240, 228) !important;
}

.stock_type_txt_button .B {
	color: red;
	background-color: rgb(255, 243, 245) !important;
}

.stock_type_txt_button .C {
	color: rgb(75, 212, 205);
	background-color: rgb(223, 255, 251) !important;
}

:deep(.el-input-group__append) {
	background: #ff8a5c;
}

.caozuo {
	top: 11px;
	position: absolute;
}

.caozuo .el-icon {
	margin-right: 10px;
	display: inline;
}

:deep(.district .el-input-group__prepend) {
	background-color: #fff;
	color: #ff8a5c;
}

.el-input-number--small {
	line-height: 1.375rem;
	width: 5.5rem;
	height: 1.8rem;

	:deep(.el-icon) {
		color: #000000 !important;
		transform: scale(1) !important;
	}
}

:deep(.district .el-input-group__append) {
	background-color: #fff;
	color: #ff8a5c;
}

:deep(.el-image) {
	border-radius: 3px;
	height: 38px;
	width: 38px;
	display: inline-block;
	display: flex;
}

:deep(.acquiesce .el-button) {

	border: 0;
}

:deep(.info .el-button:hover) {
	color: #fff;
	background-color: #ff8a5c;
	border-color: #ff8a5c;
}

:deep(.name .el-button:hover) {
	color: #ff8a5c;
}

:deep(.name .el-button:active) {
	color: #ff8a5c;
}

:deep(.el-pagination.is-background .el-pager li.is-active) {
	background-color: #ff8a5c;
}

:deep(.el-form-item__label) {
	font-size: 13px;
}

:deep(.el-form-item) {

	margin-bottom: 8px;
}

.logo_m {
	margin: 15px 0px 15px 0px;
	height: auto;
}

.contact-dialog {
    :deep(.el-dialog) {
        border-radius: 20px;
        overflow: hidden;
    }
    
    :deep(.el-dialog__header) {
        margin: 0;
        padding: 0;
    }
    
    :deep(.el-dialog__body) {
        padding: 0;
    }
    
    :deep(.el-dialog__footer) {
        padding: 16px 24px 24px;
    }
}

.contact-card {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    border-radius: 16px;
    padding: 28px 20px;
    text-align: center;
    margin-bottom: 24px;
    position: relative;
    overflow: hidden;
}

.contact-card::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -50%;
    width: 200px;
    height: 200px;
    background: radial-gradient(circle, rgba(255,255,255,0.3) 0%, transparent 70%);
    border-radius: 50%;
}

.contact-avatar {
    position: relative;
    z-index: 1;
}

.avatar-circle {
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, #ffb08c 0%, #ff9a6b 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
    color: white;
    box-shadow: 0 8px 24px rgba(255, 176, 140, 0.4);
    animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.05); }
}

.contact-name {
    position: relative;
    z-index: 1;
    font-size: 22px;
    font-weight: 700;
    color: #2d3748;
    letter-spacing: 0.5px;
}

.contact-info-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.info-item {
    display: flex;
    align-items: center;
    padding: 18px 20px;
    background: #f8fafc;
    border-radius: 14px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: 2px solid transparent;
    cursor: pointer;
    position: relative;
}

.info-item:hover {
    background: white;
    border-color: #ff8a5c;
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(255, 138, 92, 0.15);
}

.info-icon-wrapper {
    width: 52px;
    height: 52px;
    background: linear-gradient(135deg, #ffb08c 0%, #ff9a6b 100%);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    color: white;
    flex-shrink: 0;
}

.phone-icon {
    background: linear-gradient(135deg, #ffb08c 0%, #ff9a6b 100%);
}

.info-icon-wrapper .el-icon {
    font-size: 24px;
}

.info-detail {
    flex: 1;
}

.info-tag {
    font-size: 12px;
    color: #94a3b8;
    margin-bottom: 6px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.info-text {
    font-size: 17px;
    font-weight: 600;
    color: #1e293b;
    letter-spacing: 0.3px;
}

.phone-text {
    color: #ff9a6b;
}

.copy-hint {
    font-size: 11px;
    color: #ff9a6b;
    background: rgba(255, 176, 140, 0.1);
    padding: 4px 10px;
    border-radius: 6px;
    font-weight: 500;
    opacity: 0;
    transition: all 0.3s ease;
}

.info-item:hover .copy-hint {
    opacity: 1;
}

.dialog-footer {
    display: flex;
    gap: 12px;
}

.close-btn {
    flex: 1;
    border-radius: 10px;
    height: 44px;
    font-weight: 500;
    border-color: #e2e8f0;
    color: #64748b;
}

.close-btn:hover {
    background: #f1f5f9;
    border-color: #cbd5e1;
    color: #475569;
}

.copy-btn {
    flex: 2;
    border-radius: 10px;
    height: 44px;
    font-weight: 600;
    background: linear-gradient(135deg, #ffb08c 0%, #ff9a6b 100%);
    border: none;
    transition: all 0.3s ease;
}

.copy-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(255, 176, 140, 0.4);
}
</style>

